import { render, staticRenderFns } from "./FiltroObservacoes.vue?vue&type=template&id=c0a78386"
import script from "./FiltroObservacoes.vue?vue&type=script&lang=js"
export * from "./FiltroObservacoes.vue?vue&type=script&lang=js"
import style0 from "./FiltroObservacoes.vue?vue&type=style&index=0&id=c0a78386&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports